import React, { Component } from 'react';
import { Field } from 'formik';
import { withAsyncActions } from 'react-async-client';
import * as yup from 'yup';

import ModalForm, { modalFormPropTypes } from 'components/common/ModalForm';
import Input from 'components/common/form/Input';
import {
    postProductDepartment,
    putProductDepartment,
    deleteProductDepartment,
    formAutoOptions,
} from 'actions/asyncActions';

const validationSchema = yup.object().shape({
    name: yup.string().trim().required()
});

@withAsyncActions({
    postAction: postProductDepartment,
    putAction: putProductDepartment,
    deleteAction: deleteProductDepartment,
}, formAutoOptions)
export default class NetworkModal extends Component {
    static propTypes = modalFormPropTypes;

    renderForm = formProps => {
        return (
            <div>
                <Field
                    name='name'
                    component={Input}
                    label='Название:'
                    placeholder='Введите название' />
            </div>
        );
    }

    render() {
        return (
            <ModalForm
                {...this.props}
                createTitle={'Добавить департамент'}
                editTitle={'Редактировать департамент'}
                validationSchema={validationSchema}
                renderForm={this.renderForm}
            />
        );
    }
}
